import Vue from 'vue'
import html2canvas from 'html2canvas'
export default Vue.extend({
  data () {
    return {
      fileSuffix: '',
      receiptClass: 'receipt--email'
    }
  },
  methods: {
    trimTransparentArea (srcCanvas) {
      const ctx = srcCanvas.getContext('2d')
      const { width, height } = srcCanvas
      const pixels = ctx.getImageData(0, 0, width, height).data

      let top = null; let left = null; let right = null; let bottom = null

      // 투명 영역 확인
      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          const idx = (y * width + x) * 4
          const alpha = pixels[idx + 3]
          if (alpha !== 0) {
            if (top === null) top = y
            if (left === null || x < left) left = x
            if (right === null || x > right) right = x
            bottom = y
          }
        }
      }

      // 전부 투명하면 원본 그대로 반환
      if (top === null) return srcCanvas

      const trimWidth = right - left + 1
      const trimHeight = bottom - top + 1

      // 새 캔버스 생성 후 필요한 부분만 복사
      const out = document.createElement('canvas')
      out.width = trimWidth
      out.height = trimHeight
      const octx = out.getContext('2d')
      octx.drawImage(srcCanvas, left, top, trimWidth, trimHeight, 0, 0, trimWidth, trimHeight)

      return out
    },
    async saveAsImage () {
      console.log('## saveAsImage')
      await this.$nextTick() // DOM 렌더 완료 보장
      const element = this.$refs.receiptContent.$refs.receiptRoot
      if (!element) {
        console.error('receiptRoot not found')
        return
      }

      // 원본 화면에 영향을 주지 않기 위해 DOM clone
      const cloneElement = element.cloneNode(element)

      // 화면에 보이지 않게 DOM clone 추가
      const sandbox = document.createElement('div')
      Object.assign(sandbox.style, {
        position: 'fixed',
        inset: 0,
        opacity: 0,
        pointerEvents: 'none',
        zIndex: -1
      })
      document.body.appendChild(sandbox)
      sandbox.appendChild(cloneElement)

      // 배경색
      cloneElement.style.backgroundColor = '#ffffffff'

      this.fileSuffix = this.$store.getters.orderSeq
      try {
        const canvas = await html2canvas(cloneElement, {
          scale: 2,
          useCORS: false,
          allowTaint: true,
          logging: true,
          x: Math.round(cloneElement.left + window.scrollX),
          y: Math.round(cloneElement.top + window.scrollY),
          scrollX: 0,
          scrollY: 0,
          backgroundColor: null,
          ignoreElements: (el) => {
            return el.nodeName.toLocaleLowerCase() === 'canvas' ||
            el.classList.contains('buttons') ||
            el.getAttribute('loading') === 'lazy'
          }
        })
        const trimmedCanvas = this.trimTransparentArea(canvas) // 투명 영역 제거
        const dataUrl = trimmedCanvas.toDataURL('image/png')
        console.log(dataUrl)

        const link = document.createElement('a')
        link.href = dataUrl
        link.download = `${this.fileSuffix}_receipt.png`
        link.click()
      } catch (err) {
        console.error(err)
        this.toastBottom(this, '이미지 저장에 실패했습니다.')
      } finally {
        // DOM clone 제거
        document.body.removeChild(sandbox)
      }
    },

    async createReceiptCanvasForEmail () {
      try {
        const targetElement = '.' + this.receiptClass
        const target = document.querySelector(targetElement)
        this.fileSuffix = this.$store.getters.orderSeq
        if (!target) {
          console.error('대상 엘리먼트를 찾을 수 없습니다.')
          return
        }

        const canvas = await html2canvas(target, {
          backgroundColor: null,
          scale: window.devicePixelRatio
        })

        // Blob으로 변환 후 다운로드
        canvas.toBlob((blob) => {
          const url = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.href = url
          a.download = `${this.fileSuffix}_receipt.png`
          a.click()

          URL.revokeObjectURL(url)
        }, 'image/png')
      } catch (error) {
        this.toastBottom(this, '이미지 저장에 실패했습니다.')
      }
    }
  }

})
